import { formatter } from '../helpers/formatters.esm.js';
import { capitalizeFirstCharacter } from '../helpers/capitalizeFirstCharacter.esm.js';

/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
const verificationOptions = [
    'capitalize',
    'weekday',
    'year',
];
/**
 * Format a date or date-parseable string to a mostly text-based date and month with additional options for showing year and weekday
 *
 *- Example outputs: `24 dec. 2020` | `tors 24 dec. 2020` | `24 dec.` |  `tors 24 dec.` | `2020-12-24`
 */
const format = (date, options = {}) => {
    if (!(options === null || options === void 0 ? void 0 : options.style) || options.style === 'readable') {
        const out = formatter(date, Object.assign(Object.assign(Object.assign({}, ((options === null || options === void 0 ? void 0 : options.weekday) && { weekday: 'short' })), ((options === null || options === void 0 ? void 0 : options.year) && { year: 'numeric' })), { day: 'numeric', month: 'short', locale: options === null || options === void 0 ? void 0 : options.locale, timeZone: options === null || options === void 0 ? void 0 : options.timeZone }));
        return (options === null || options === void 0 ? void 0 : options.capitalize) ? capitalizeFirstCharacter(out) : out;
    }
    Object.keys(options).forEach((prop) => {
        const option = prop;
        if (verificationOptions.includes(option)) {
            throw TypeError(`The property '${option}' cannot be used with the numeric style.`);
        }
    });
    return formatter(date, {
        dateStyle: 'short',
        locale: options === null || options === void 0 ? void 0 : options.locale,
        timeZone: options === null || options === void 0 ? void 0 : options.timeZone,
    });
};
const date = { format };

export { date };
